import {ChartType, ResourceType} from 'common/report/constants';
import {FilterClause} from 'common/report/insights/models/filter-clause';
import {BehaviorShowClause} from 'common/report/insights/models/show-clause';
import {getEventValueAndLabel} from 'common/report/util/events';
import {assert} from 'common/util';
import {assertUnreachable} from 'common/util/typescript';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';
import {FiltersOperator, QueryEventEntry} from 'common/query-builder/query-entry-section/types';
import {TrackName as DataTableTrackName} from 'common/components/data-table/types';
import {FilterDeterminer} from 'common/report/insights/util/types';

function determinerToFiltersOperator(determiner: FilterDeterminer) {
  if (!determiner) {
    return null;
  }
  switch (determiner) {
    case `any`:
      return FiltersOperator.Or;
    case `all`:
      return FiltersOperator.And;
    default:
      assertUnreachable(determiner);
  }
}

export function convertSegmentForEventsInspector(behaviorShowClauses: BehaviorShowClause[]): QueryEventEntry[] {
  return behaviorShowClauses.map((showClause) => {
    const showClauseFilters = showClause.behavior.filters || [];
    const determiner = showClauseFilters.find((filter: FilterClause) => filter.determiner)?.determiner;
    const filters: PropertyFilter[] = showClauseFilters.map(
      (filter: FilterClause): PropertyFilter => {
        return new FilterClause(filter).toPropertyFilter();
      },
    );
    const {custom, name, id} = showClause.behavior.value;
    assert(!Array.isArray(name));
    const {label, value} = getEventValueAndLabel({name, custom, id});
    const queryEventEntry: QueryEventEntry = {
      type: ResourceType.Event,
      dataGroupId: showClause.behavior.dataGroupId,
      event: {
        label,
        value,
        custom,
        id,
      },
      filters,
      filtersOperator: determinerToFiltersOperator(determiner),
    };
    return queryEventEntry;
  });
}

export function hasDataTable(chartType: ChartType) {
  return [ChartType.Line, ChartType.Metric, ChartType.Pie, ChartType.FunnelSteps].includes(chartType);
}

export function getDataTableTrackName(chartType: ChartType) {
  switch (chartType) {
    case ChartType.Line:
      return DataTableTrackName.InsightsLine;
    case ChartType.Metric:
      return DataTableTrackName.InsightsMetric;
    case ChartType.Pie:
      return DataTableTrackName.InsightsPie;
    case ChartType.FunnelSteps:
      return DataTableTrackName.FunnelsSteps;
    default:
      throw new Error(`Data table not supported for ${chartType}`);
  }
}
